import React from 'react';
import {
  EmptyState, EmptyStateContent, EmptyStateSize, EmptyStateSurfaceIcon, SurfaceIcons,
} from '@bingads-webui-fluent-component/empty-state';
import { useDataSource } from '@bingads-webui-react/data-source';
import { I18n } from '../types';

const NoSearchResultsMessage = ({ i18n, showSelectedOnly }: { i18n: I18n, showSelectedOnly: boolean }) => {
  const { searchTerm } = useDataSource();
  const searchTermTrimmed = searchTerm.trim();
  const message = showSelectedOnly
    ? i18n.getString(_TL_('No results found for "{{searchTerm}}" in the selected items.'), { searchTerm: searchTermTrimmed })
    : i18n.getString(_TL_('No results found for "{{searchTerm}}".'), { searchTerm: searchTermTrimmed });

  return (
    <EmptyState size={EmptyStateSize.mediumSurface}>
      <EmptyStateContent
        title={message}
      >
        <EmptyStateSurfaceIcon icon={SurfaceIcons.Search} />
      </EmptyStateContent>
    </EmptyState>
  );
};

export default NoSearchResultsMessage;
